<template>
  <div class="py-2 my-2 text-base font-bold text-[#292C2E] text-center flex items-center before:flex-1 before:bg-[#DFE4E8] before:h-px before:mr-4 after:flex-1 after:bg-[#DFE4E8] after:h-px after:ml-4">
    <slot />
  </div>
</template>
